import { create } from "zustand";

interface ModalStore {
  activeModal: string | null;
  open: (id: string) => void;
  close: () => void;
}

/**
 * One modal at a time, app-wide. Storing the *active id* rather than a boolean per
 * modal is what makes that guarantee structural: opening one implicitly closes
 * whatever was open.
 */
export const useModalStore = create<ModalStore>((set) => ({
  activeModal: null,
  open: (id) => set({ activeModal: id }),
  close: () => set({ activeModal: null }),
}));

export function useModal(id: string) {
  const activeModal = useModalStore((state) => state.activeModal);
  const open = useModalStore((state) => state.open);
  const close = useModalStore((state) => state.close);

  return {
    isOpen: activeModal === id,
    open: () => open(id),
    close,
  };
}
